// src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    components: {
        MuiContainer: {
          styleOverrides: {
            root: {
              width: "70%", // Default width for larger screens
              maxWidth: "none", // Ensures it doesn't limit the width
              margin: "0 auto", // Centers the container
              "@media (max-width: 600px)": {
                width: "100%", // Full width for smaller screens
              },
            },
          },
        },
      },
  typography: {
    // Apply global font size for different screen sizes
    fontFamily: "sans-serif",
    h1: {
      fontSize: '2.5rem', // default font size for large screens
      '@media (max-width:600px)': {
        fontSize: '1.8rem', // font size for mobile screens
      },
    },
    h2: {
      fontSize: '2.5 rem',
      fontWeight:"bold",
      color: "#0279c6",
      '@media (max-width:600px)': {
        fontSize: '0.8 rem', // font size for mobile screens
      },
    },
    h3: {
      fontSize: '1.0rem',
      '@media (max-width:600px)': {
        fontSize: '0.8rem', // font size for mobile screens
      },
     
    },
    body1: {
      fontSize: '1rem',
      '@media (max-width:600px)': {
        fontSize: '0.9rem', // font size for mobile screens
      },
    },
    body2: {
      fontSize: '0.875rem',
      '@media (max-width:600px)': {
        fontSize: '0.8rem', // font size for mobile screens
      },
    },
  },
});

export default theme;
